module.exports = __webpack_public_path__ + "static/Slavica Markovic-Pticek-830c07d3bb421ef367ce36533674d170.png";